import { NAVIGATION_PATHS } from "@/contexts/appNavContext";
import { hasPermissionsToAccessUrl } from "@/utils/permissionUtils";

export const getDefaultRoute = (
  userMedspa:
    | {
        medspa: { id: string };
        role: string;
        roleId?: string;
        urlPermissions?: {
          urlPattern?: string;
        }[];
      }
    | undefined
) => {
  if (!userMedspa) return "/sign-in";
  const urlPermissions =
    userMedspa.urlPermissions
      ?.map((permission) => permission?.urlPattern)
      .filter(Boolean) ?? [];

  // First try the default routes in specific order
  const defaultRoutes = [
    NAVIGATION_PATHS.REVIEW_CHARTS(userMedspa.medspa.id),
    NAVIGATION_PATHS.VISITS(userMedspa.medspa.id),
    NAVIGATION_PATHS.REVIEW_GFES(userMedspa.medspa.id),
    NAVIGATION_PATHS.CLIENTS(userMedspa.medspa.id),
  ];

  const matchedDefaultUrl = defaultRoutes.find((url) =>
    hasPermissionsToAccessUrl(url, urlPermissions)
  );

  if (matchedDefaultUrl) {
    return matchedDefaultUrl;
  }

  // If no default route matches, try all other navigation paths
  // This is due to the roles customization, a front desk could not have access
  // to default routes but have access to other tabs
  const allNavigationPaths = Object.values(NAVIGATION_PATHS).map((pathFn) =>
    pathFn(userMedspa.medspa.id)
  );

  const matchedUrl = allNavigationPaths.find((url) =>
    hasPermissionsToAccessUrl(url, urlPermissions)
  );

  return matchedUrl || "/404";
};
